import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { CHECK_DOMAIN } from "../../../../gql/hosting";
import { useMutation } from "@apollo/client";
import { CREATE_CART_DOMAIN } from "../../../../gql/cart";
import { useCookies } from "react-cookie";
import { useRouter } from "next/dist/client/router";
import { toast } from "react-toastify";
const CommonSearch = () => {
  const router = useRouter();
  const [isAvailable, setIsAvailable] = React.useState();
  const [domainName, setDomainName] = React.useState("");
  const { register, setValue, handleSubmit, control } = useForm({
    defaultValues: {
      domain_name: "",
    },
  });
  const [cookie] = useCookies();

  const [addToCartDomain, { loading: loadAddDomain, error: errorAddDomain }] =
    useMutation(CREATE_CART_DOMAIN, {
      update(cache, { data }) {
        const list = cache.readQuery({
          query: FETCH_CART,
          variables: {
            action_type: 1,
          },
        });
        cache.writeQuery({
          query: FETCH_CART,
          data: {
            billing_hosting: {
              ...list.billing_hosting,
              carts: [
                ...list.billing_hosting.carts,
                data.billing.cartOps.createCartDomain,
              ],
            },
          },
        });
      },
    });
  const [checkDomain, { loading: loadCheckDomain, error: errorCheckDomain }] =
    useMutation(CHECK_DOMAIN, {
      onCompleted: (resp) => {
        setIsAvailable(resp.domain.domainOps.checkDomain.available);
      },
      onError: (resp) => {
        toast(resp.message, {
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_LEFT,
        });
      },
    });

  React.useEffect(() => {
    if (router.query.domain) {
      setValue("domain_name", router.query.domain);
      setDomainName(router.query.domain);

      checkDomain({
        variables: {
          Domain: router.query.domain,
        },
      });
    }
  }, [router.query.domain]);

  const handleCheckDomain = (data) => {
    setIsAvailable();
    setDomainName(data.domain_name);

    checkDomain({
      variables: {
        Domain: data.domain_name,
      },
    });
  };

  const handleAddCartDomain = () => {
    if (cookie.access_token === undefined) {
      window.open(
        `${process.env.REACT_APP_NEW_DOMAIN}login?continue=${window.location.href}?domain=${domainName}`
      );
    } else {
      addToCartDomain({
        variables: {
          input: {
            name: domainName,
            is_premium: false,
          },
          // currency: currency,
        },
      });
    }

    addToCartDomain({
      variables: {
        input: {
          name: domainName,
          is_premium: false,
        },
        // currency: currency,
      },
    });
  };

  return (
    <div>
      <form onSubmit={handleSubmit(handleCheckDomain)}>
        <div className="input-group ">
          <input
            {...register("domain_name", { required: true })}
            className="border-primary form-control"
          />

          <span className="input-group-append">
            {isAvailable === 1 ? (
              <button
                className="btn btn-primary d-flex align-items-center"
                onClick={handleAddCartDomain}
              >
                <span className="icon-cart pe-2"></span>
                Tambah
              </button>
            ) : (
              <button
                className="btn btn-outline-primary  "
                type="submit"
                disabled={loadCheckDomain}
              >
                <span className="icon-search"></span>
              </button>
            )}
          </span>
        </div>
      </form>
      <div className="d-flex align-items-center p-1">
        {loadCheckDomain ? (
          <div className="p-1 d-flex align-items-center">
            <div className="spinner-border text-primary" role="status"></div>
            <p className="ps-2 mb-0 fw-bolder">Loading...</p>
          </div>
        ) : errorCheckDomain ? (
          <div className="p-1 d-flex align-items-center">
            <div className="icon-cancel-circle fs-5 text-danger"></div>
            <p className="ps-2 mb-0 fw-bolder text-danger">
              {errorCheckDomain.message === "record not found"
                ? "Maaf, domain extension belum tersedia"
                : errorCheckDomain.message}
            </p>
          </div>
        ) : null}
        {isAvailable === 1 ? (
          <div className="p-1 d-flex align-items-center">
            <span className="icon-tick text-success fs-5 pe-1"></span>
            <p className="px-2 mb-0 fw-bolder">Domain tersedia!</p>
            <a
              className="text-primary text-decoration-underline pointer"
              onClick={() => setIsAvailable()}
            >
              Check domain lainnya?
            </a>
          </div>
        ) : isAvailable === 0 ? (
          <div className="p-1 d-flex align-items-center">
            <div className="icon-cancel-circle fs-5 text-danger"></div>
            <p className="px-2 mb-0 fw-bolder text-danger">
              Maaf, domain tidak tersedia.
            </p>
            <a
              className="text-primary text-decoration-underline pointer"
              onClick={() => setIsAvailable()}
            >
              Check domain lainnya.
            </a>
          </div>
        ) : null}
        {errorAddDomain && <p>Error add to cart...</p>}
      </div>
    </div>
  );
};

export default CommonSearch;
